import * as Phaser from "phaser-ce"
import { colorNum } from "../utils/ColorUtils"
import { Movable, Sprites } from "../utils/Sprites"
import { GenericAssets } from "./GenericAssets"

enum ShapeValue {
    CIRCLE,
    RECTANGLE,
    LINE
}

interface ShapeConfig {
    shape?: ShapeValue
    lineColor?: number
    fillColor?: number
    lineWidth?: number
    cornerRounding?: number
    group?: Phaser.Group
    fillAlpha?: number
}

export class Shape {
    graphics: Phaser.Graphics
    /**
     * This can help for things like centering text in the box.
     */
    invisibleSprite: Phaser.Sprite

    constructor(
        game: Phaser.Game, x: number, y: number, width: number, height: number,
        {shape = ShapeValue.RECTANGLE, lineColor = colorNum.black, fillColor, lineWidth = 4, cornerRounding, group, fillAlpha = 1}:
            ShapeConfig = {}
    ) {

        this.graphics = game.add.graphics(x, y)
        if (fillColor != null) {
            this.graphics.beginFill(fillColor, fillAlpha)
        }
        this.graphics.lineStyle(lineWidth, lineColor, 1)
        if (shape === ShapeValue.RECTANGLE) {
            if (cornerRounding != null) {
                this.graphics.drawRoundedRect(0, 0, width, height, cornerRounding)
            } else {
                this.graphics.drawRect(0, 0, width, height)
            }
        } else if (shape === ShapeValue.CIRCLE) {
            this.graphics.drawCircle(0, 0, width)
        } else if (shape === ShapeValue.LINE) {
            // this.graphics.moveTo(x, y)
            this.graphics.lineTo(width, length)
        }
        if (fillColor != null) {
            this.graphics.endFill()
        }

        this.invisibleSprite = Sprites.add(game, GenericAssets.BLACK_PIXEL, {x, y})
        this.invisibleSprite.width = width
        this.invisibleSprite.height = height === undefined ? width : height
        if (shape === ShapeValue.CIRCLE) {
            this.invisibleSprite.x -= width / 2
            this.invisibleSprite.y -= width / 2
        }
        this.invisibleSprite.alpha = 0

        if (group) {
            group.add(this.graphics)
            group.add(this.invisibleSprite)
        }
    }

    static makeShapeAround = (
        game: Phaser.Game, around: Movable, padding: number, config: ShapeConfig
    ) => {
        return new Shape(game, around.x - padding, around.y - padding, around.width + padding * 2, around.height + padding * 2, config)
    }

    destroy = () => {
        this.graphics.destroy()
        this.invisibleSprite.destroy()
    }
}

export class Rectangle extends Shape {
    constructor(
        game: Phaser.Game, x: number, y: number, width: number, height: number,
        {lineColor = colorNum.black, fillColor, lineWidth = 4, cornerRounding, group, fillAlpha = 1}:
            { lineColor?: number, fillColor?: number, lineWidth?: number, cornerRounding?: number, group?: Phaser.Group, fillAlpha?: number } = {}
    ) {
        super(game, x, y, width, height, {shape: ShapeValue.RECTANGLE, lineColor, fillColor, lineWidth, cornerRounding, group, fillAlpha})
    }
}

export class Circle extends Shape {
    constructor(
        game: Phaser.Game, x: number, y: number, width: number,
        {lineColor = colorNum.black, fillColor, lineWidth = 4, cornerRounding, group, fillAlpha = 1}:
            { lineColor?: number, fillColor?: number, lineWidth?: number, cornerRounding?: number, group?: Phaser.Group, fillAlpha?: number } = {}
    ) {
        super(game, x, y, width, undefined, {shape: ShapeValue.CIRCLE, lineColor, fillColor, lineWidth, cornerRounding, group, fillAlpha})
    }
}

export class Line extends Shape {
    constructor(
        game: Phaser.Game, x1: number, y1: number, x2: number, y2: number, {
            lineColor = colorNum.black, group, fillAlpha = 1, lineWidth = 1,
        }: {
            lineColor?: number, group?: Phaser.Group, fillAlpha?: number, lineWidth?: number
        } = {}
    ) {
        super(game, x1, y1, x2, y2, {shape: ShapeValue.LINE, lineColor, group, fillAlpha, lineWidth})

    }

}
